// js
import './js/core-jquery';
import './js/home';
// import './js/single_product';
// import './js/cart';
// import './js/event';

// css
import './css/main_css.js'
